/**
* @Author: Matthias Gohla <Matze>
* @Date:   2016-09-23T12:13:54+02:00
* @Email:  matze_lebt@gmx.de
* @Last modified by:   mBook
* @Last modified time: 2016-10-06T16:24:38+02:00
*/


import React, {Component} from 'react';
import PropTypes from 'prop-types';
import MFooterCheckout from './MFooterCheckout';
import ALinkFooter from './ALinkFooter';

/**
 * OFormareaCheckout - wraps the checkout content
**/
class OFormareaCheckout extends Component {
  /**
     * TODO jsdoc
     *
     * @return {object}
     */
  render() {
    const {
      children,
      footerLinks,
    } = this.props;

    const links = [];
    for (const i in footerLinks) {
      const entry = footerLinks[i];
      links.push(
          <ALinkFooter
            key={'o-formarea-checkout-a-link-footer-' + i}
            href={entry.href || null}
            onPress={entry.callback || null}
            label={entry.label || null}
            target={entry.target || null}
          />
      );
    }
    return (
      <div className="o-formarea o-formarea-checkout">
        <div className="o-formarea-checkout__content">
          {children}
        </div>
        { links.length > 0 &&
                        <MFooterCheckout>
                          {links}
                        </MFooterCheckout>
        }
      </div>
    );
  }
}

OFormareaCheckout.propTypes = {
  children: PropTypes.any,
  footerLinks: PropTypes.any,
};
OFormareaCheckout.defaultProps = {
  footerLinks: {},
};
export default OFormareaCheckout;

